
export const translations = {
  en: {
    dashboard: "Dashboard",
    gateway_dashboard: "Gateway dashboard",
    system_status: "SYSTEM STATUS",
    multichannel_gateway: "Multichannel Gateway",
    optimize_paths: "Optimize distribution paths for peak efficiency and maximum reach.",
    txe_usage: "TXE-Usage",
    used_available: "USED / AVAILABLE",
    upgrade_plan: "Upgrade Plan",
    details: "Details",
    sync_view: "Search",
    syncing: "Syncing...",
    company: "Company",
    ledger_view: "Ledger View",
    process: "Process",
    status: "Status",
    debitor: "Debitor",
    creditor: "Creditor",
    topology_monitoring: "Topology Monitoring",
    transaction_overview: "Transaction Overview",
    showing_x_of_y: "Showing {x} of {y} items",
    type: "Type",
    doc_number: "Document Number",
    date: "Date",
    channel: "Channel",
    direction: "Direction",
    actions: "Action",
    send: "Send",
    receive: "Receive",
    completed: "COMPLETED",
    pending: "PENDING",
    failed: "FAILED",
    rejected: "REJECTED",
    ready_to_route: "Ready to Route",
    primary_ingestion: "Primary Ingestion",
    files: "Files",
    advanced_filter: "Advanced Filter",
    main: "Main",
    settings: "Settings",
    debtors: "Debtors",
    creditors: "Creditors",
    invoice: "Invoice",
    orders: "Orders",
    delivery_notes: "Delivery Notes",
    credit_notes: "Credit Notes",
    general_settings: "General Settings",
    channel_settings: "Channel Settings",
    plan_billing: "Plan & Billing",
    profile_settings: "Profile Settings",
    sign_out: "Sign out",
    product_tour: "Product tour",
    tutorial: "Tutorial",
    search_resources: "Search resources...",
    auto_refresh: "Auto-Refresh",
    biller_details: "Biller Details",
    branding: "Branding",
    legal_name: "Legal Name",
    default_lang: "Default Language",
    sector: "Sector",
    financial_interface: "Financial Interface",
    iban: "IBAN",
    currency: "Currency",
    update: "Update",
    save_next: "Save Next",
    back: "Back",
    cancel: "Cancel",
    invoice_management: "Invoice",
    order_management: "Order",
    search_invoices: "Search invoices...",
    customer_name: "Customer Name",
    description: "Description",
    due_date: "Due Date",
    amount: "Amount",
    sent: "Sent",
    draft: "Draft",
    requirements: "Requirements",
    enterprise_id: "Enterprise ID",
    iid_clearing: "IID / Clearing",
    back_to_dashboard: "Dashboard",
    welcome_back: "Welcome back!",
    sign_in: "Sign In",
    personal_information: "Personal Information",
    first_name: "First Name",
    last_name: "Last Name",
    email_address: "Email Address",
    interface_preferences: "Interface Preferences",
    language: "Language",
    timezone: "Timezone",
    change_avatar: "Change Avatar",
    delete_photo: "Delete Photo",
    save_changes: "Save Changes",
    discard_changes: "Discard Changes",
    channel_configuration: "Channel Configuration",
    endpoint: "ENDPOINT",
    not_configured: "NOT YET CONFIGURED",
    setup_required: "Setup Required",
    active: "Active",
    paused: "Paused",
    live: "Live",
    inactive: "Inactive",
    expand_reach: "Expand your reach?",
    contact_engineer: "Contact Engineer",
    current_plan: "Current Plan",
    usage_tracker: "Usage Tracker",
    next_reset: "Next Reset",
    payment_method: "Payment Method",
    billing_history: "Billing History",
    invoice_id: "Invoice ID",
    delivery_method: "Delivery method",
    exchange_server: "Exchange Server",
    smtp_server: "SMTP Server",
    host: "Host",
    port: "Port",
    login_email: "Login eMail",
    tenant_id: "Tenant ID",
    client_id: "Client ID",
    client_secret: "Client Secret",
    verify_connection: "Verify Connection",
    verification_pending: "Verification Pending",
    email_delivery_config: "eMail delivery configuration",
    emails_per_day: "eMails per day",
    sender_email: "Sender eMail-Address",
    same_as_login: "Same as login",
    attachment_standard: "Attachment Standard",
    standard_pdf: "Standard PDF",
    hybrid_pdf_xml: "Hybrid PDF with embedded XML data",
    email_template: "eMail Template",
    subject: "Subject",
    establish_gateway: "Establish Gateway",
    gateway_established: "Gateway established",
    email_gateway_verified: "The eMail gateway connection has been successfully verified and saved.",
    continue_dashboard: "Continue to Dashboard"
  },
  de: {
    dashboard: "Dashboard",
    gateway_dashboard: "Gateway-Übersicht",
    system_status: "SYSTEMSTATUS",
    multichannel_gateway: "Multichannel-Gateway",
    optimize_paths: "Optimieren Sie Verteilungswege für maximale Effizienz und Reichweite.",
    txe_usage: "TXE-Nutzung",
    used_available: "GENUTZT / VERFÜGBAR",
    upgrade_plan: "Plan upgraden",
    details: "Details",
    sync_view: "Suche",
    syncing: "Synchronisiere...",
    company: "Unternehmen",
    ledger_view: "Ledger-Ansicht",
    process: "Prozess",
    status: "Status",
    debitor: "Debitor",
    creditor: "Kreditor",
    topology_monitoring: "Topologie-Überwachung",
    transaction_overview: "Transaktionsübersicht",
    showing_x_of_y: "Zeige {x} von {y} Einträgen",
    type: "Typ",
    doc_number: "Dokumentennummer",
    date: "Datum",
    channel: "Kanal",
    direction: "Richtung",
    actions: "Aktion",
    send: "Senden",
    receive: "Empfangen",
    completed: "ABGESCHLOSSEN",
    pending: "AUSSTEHEND",
    failed: "FEHLGESCHLAGEN",
    rejected: "ABGEWIESEN",
    ready_to_route: "Bereit zum Routing",
    primary_ingestion: "Primäre Aufnahme",
    files: "Dateien",
    advanced_filter: "Erweiterter Filter",
    main: "Hauptmenü",
    settings: "Einstellungen",
    debtors: "Debitoren",
    creditors: "Kreditoren",
    invoice: "Rechnungen",
    orders: "Bestellungen",
    delivery_notes: "Lieferscheine",
    credit_notes: "Gutschriften",
    general_settings: "Allgemein",
    channel_settings: "Kanaleinstellungen",
    plan_billing: "Plan & Abrechnung",
    profile_settings: "Profil-Einstellungen",
    sign_out: "Abmelden",
    product_tour: "Produkttour",
    tutorial: "Tutorial",
    search_resources: "Ressourcen suchen...",
    auto_refresh: "Auto-Refresh",
    biller_details: "Rechnungssteller-Details",
    branding: "Markenauftritt",
    legal_name: "Rechtlicher Name",
    default_lang: "Standardsprache",
    sector: "Branche",
    financial_interface: "Finanzschnittstelle",
    iban: "IBAN",
    currency: "Währung",
    update: "Aktualisieren",
    save_next: "Speichern & Weiter",
    back: "Zurück",
    cancel: "Abbrechen",
    invoice_management: "Rechnung",
    order_management: "Bestellung",
    search_invoices: "Rechnungen suchen...",
    customer_name: "Kundenname",
    description: "Beschreibung",
    due_date: "Fälligkeitsdatum",
    amount: "Betrag",
    sent: "Gesendet",
    draft: "Entwurf",
    requirements: "Anforderungen",
    enterprise_id: "Unternehmens-ID",
    iid_clearing: "IID / Clearing",
    back_to_dashboard: "Dashboard",
    welcome_back: "Willkommen zurück!",
    sign_in: "Sign In",
    personal_information: "Persönliche Informationen",
    first_name: "Vorname",
    last_name: "Nachname",
    email_address: "E-Mail-Adresse",
    interface_preferences: "Schnittstellen-Einstellungen",
    language: "Sprache",
    timezone: "Zeitzone",
    change_avatar: "Avatar ändern",
    delete_photo: "Foto löschen",
    save_changes: "Änderungen speichern",
    discard_changes: "Verwerfen",
    channel_configuration: "Kanal-Konfiguration",
    endpoint: "ENDPUNKT",
    not_configured: "NOCH NICHT KONFIGURIERT",
    setup_required: "Einrichtung erforderlich",
    active: "Aktiv",
    paused: "Pausiert",
    live: "Live",
    inactive: "Inaktiv",
    expand_reach: "Reichweite vergrößern?",
    contact_engineer: "Ingenieur kontaktieren",
    current_plan: "Aktueller Plan",
    usage_tracker: "Nutzungsverfolgung",
    next_reset: "Nächster Reset",
    payment_method: "Zahlungsmethode",
    billing_history: "Rechnungshistorie",
    invoice_id: "Rechnungs-ID",
    delivery_method: "Versandart",
    exchange_server: "Exchange Server",
    smtp_server: "SMTP Server",
    host: "Host",
    port: "Port",
    login_email: "Anmelde-E-Mail",
    tenant_id: "Tenant-ID",
    client_id: "Client-ID",
    client_secret: "Client-Secret",
    verify_connection: "Verbindung prüfen",
    verification_pending: "Prüfung ausstehend",
    email_delivery_config: "E-Mail-Versandkonfiguration",
    emails_per_day: "E-Mails pro Tag",
    sender_email: "Absender-E-Mail",
    same_as_login: "Identisch mit Login",
    attachment_standard: "Anhang-Standard",
    standard_pdf: "Standard PDF",
    hybrid_pdf_xml: "Hybrid-PDF mit eingebetteten XML-Daten",
    email_template: "E-Mail-Vorlage",
    subject: "Betreff",
    establish_gateway: "Gateway einrichten",
    gateway_established: "Gateway eingerichtet",
    email_gateway_verified: "Die E-Mail-Gateway-Verbindung wurde erfolgreich verifiziert und gespeichert.",
    continue_dashboard: "Weiter zum Dashboard"
  }
};
